import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { Row, Card, Form, Input, Typography, Button, message } from 'antd';
import logo from '../../images/loginLogo.svg';

const { Title, Text, Link } = Typography;

interface IProps {
  authData?: any;
  authState?: any;
  onStateChange?: any;
}

const ConfirmSignIn: React.FC<IProps> = (props: IProps) => {
  const { authData, authState, onStateChange } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  /*
   * When the form passes client side validation, we use the CongitoUser
   * stored in authData and the code from the form to change authState to
   * signedIn. This allows us to finally display the internal app.
   *
   * On any error, we reset the form fields, set the loading state to
   * false and display the error message to the user.
   */

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const user = await Auth.confirmSignIn(authData, values.code);
      setLoading(false);
      onStateChange('signedIn', user);
    } catch (e) {
      form.resetFields();
      setLoading(false);
      message.error(e.message);
    }
  };

  const onLinkClick = () => {
    onStateChange('signIn');
  };

  return authState === 'confirmSignIn' ? (
    <Row justify="center" align="middle" className="Authenticator-page">
      <Card className="Authenticator-card Authenticator-card-fade-in">
        <img src={logo} alt="ehe-logo" className="Authenticator-logo" />
        <Form form={form} size="large" onFinish={onFinish}>
          <Title level={4}>Verify Sign In:</Title>
          <Form.Item
            name="code"
            rules={[
              {
                required: true,
                message: 'Please enter your security code!',
              },
            ]}
          >
            <Input placeholder="Enter Security Code..." />
          </Form.Item>
          <Row justify="center" className="Authenticator-margin-top">
            <Button type="primary" htmlType="submit" loading={loading}>
              Verify
            </Button>
          </Row>
          <Row justify="center" className="Authenticator-margin-top">
            <Text>
              Experiencing issues?{' '}
              <Link onClick={onLinkClick}>Back to Sign In</Link>
            </Text>
          </Row>
        </Form>
      </Card>
    </Row>
  ) : null;
};

export default ConfirmSignIn;
